import { BaseCommand } from './commands';
import { VodaDetailedBarUnbarCommand } from './VodaDetailedBarUnbarCommand';

export class VodaDetailedUnbarCommand extends VodaDetailedBarUnbarCommand {
  public definitionAlias: 'voda-detailed-unbar' = 'voda-detailed-unbar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
